import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

/**
 * Submit a delete account request to Firestore
 * @param {Object} requestData - The delete request data
 * @returns {Promise<Object>} Result object with success status
 */
export const submitDeleteRequest = async (requestData) => {
  try {
    const deleteRequestsRef = collection(db, 'delete-requests');
    
    const docRef = await addDoc(deleteRequestsRef, {
      ...requestData,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });

    console.log('Delete request submitted with ID:', docRef.id);        
    
    return {
      success: true,
      requestId: docRef.id,
      message: 'Delete request submitted successfully'
    };  
  } catch (error) {
    console.error('Error submitting delete request:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Get all delete requests (for admin use)
 * @returns {Promise<Array>} Array of delete requests
 */
export const getAllDeleteRequests = async () => {
  try {
    const { getDocs, query, orderBy } = await import('firebase/firestore');
    const deleteRequestsRef = collection(db, 'delete-requests');
    const q = query(deleteRequestsRef, orderBy('createdAt', 'desc'));
    
    const querySnapshot = await getDocs(q);
    const requests = [];
    
    querySnapshot.forEach((doc) => {
      requests.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    return {
      success: true,
      data: requests
    };
  } catch (error) {
    console.error('Error fetching delete requests:', error);
    return {
      success: false,
      error: error.message,
      data: []
    };
  }
};

/**
 * Update delete request status (for admin use)
 * @param {string} requestId - The request ID
 * @param {string} status - New status (pending, approved, rejected, completed)
 * @returns {Promise<Object>} Result object
 */
export const updateDeleteRequestStatus = async (requestId, status) => {
  try {
    const { doc, updateDoc } = await import('firebase/firestore');
    const requestRef = doc(db, 'delete-requests', requestId);
    
    await updateDoc(requestRef, {
      status,
      updatedAt: serverTimestamp()
    });
    
    return {
      success: true,
      message: 'Request status updated successfully'
    };
  } catch (error) {
    console.error('Error updating request status:', error);
    return {
      success: false,
      error: error.message
    };
  }
};
